/* eslint-disable max-len */
/* eslint-disable no-invalid-this */
/* eslint-disable comma-dangle */

const BIOPAGECLS = '.bioPage-';

// imports
import utils from './utils';

export function initPageLoader(self) {
	const This = self;
	let currentScrollPosition;

	This.linkTrigger.on('click', function(e) {
		e.preventDefault();

		let url = $(this).attr('href');

		currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

		This.loadingSpinner.addClass('is-active bioLoader');

		// set the hash
		window.location.hash = This.name;

		// check if the page was loaded
		if (!This.pageLoaded) {
			This.$wg.find(This.WG + 'page').load(`${url} main`, function() {
				This.bioPage = This.$wg.find('.bioPage');

				// load all js needed for widgets / blocks
				loadJS(This);

				// in case it had the standalone class
				This.bioPage.removeClass('is-standalone');

				This.bioPage.addClass('active');

				$('body').css({
					'overflow': 'hidden',
					'height': '100vh',
				});

				This.pageLoaded = true;

				// carousel stuff (fix width issues)
				// timeout, because css animation is set to 0.5s
				if (This.bioPage.find('.slick-initialized').length > 0) {
					setTimeout(() => {
						This.bioPage.find('.slick-initialized').each(function() {
							$(this).slick('setPosition');
						});

						$(document).trigger('resize');
					}, 750);
				}

				// css transition time
				setTimeout(() => {
					fixOverFlow(This);
					scrollSpy(This);

					This.loadingSpinner.removeClass('is-active bioLoader');
				}, 500);

				This.bioPage.on('scroll', function() {
					$(window).trigger('scroll');
				});
			});
		} else {
			$('body').css({
				'overflow': 'hidden',
				'height': '100vh',
			});

			// css transition
			setTimeout(() => {
				fixOverFlow(This);
				scrollSpy(This);

				This.loadingSpinner.removeClass('is-active bioLoader');
			}, 500);

			This.bioPage.addClass('active');
		}
	});

	This.$wg.on('click', BIOPAGECLS + 'close', function() {
		fixOverFlow(This, false);

		// clear hash
		window.location.hash = '';

		This.bioPage.removeClass('active');

		$('body').css({
			'overflow': '',
			'height': '',
		});

		document.documentElement.scrollTop = currentScrollPosition;

		setTimeout(() => {
			This.bioPage[0].scrollTop = 0;
		}, 500);
	});

	// on load, check if name is the same as the hash value
	// if it's, trigger a click manually

	let nameFromHash = window.location.hash.split('#')[1] || '';

	nameFromHash = decodeURIComponent(nameFromHash);

	if (This.name && This.name !== '' && (nameFromHash === This.name)) {
		if (This.linkTrigger.closest('.judgesContainerBlock').length == 0) {
			This.linkTrigger.trigger('click');
		} else {
			This.linkTrigger.closest('.judgesContainerBlock').find(`[data-name="${nameFromHash}"]:not(.slick-cloned) .judgeItemBlock-link`).trigger('click');
		}
		// This.linkTrigger.trigger('click');
	}
}

function loadJS(This) {
	This.bioPage.find('[data-wg]').each(function() {
		const $wg = $(this);
		const path = lowerCaseFirstLetter($wg.data('wg'));
		const name = $wg.data('wg');

		try {
			const Partial = require(`./widgets/${path}`);

			// init a new instance of the partial
			const PartialClass = new Partial[name]($wg);

			// call init function
			PartialClass.init();
		} catch (err) {
			// error
		}
	});
}

function lowerCaseFirstLetter(string) {
	return string.charAt(0).toLowerCase() + string.slice(1);
}

function fixOverFlow(This, state = true) {
	// fix overflow
	if (state) {
		This.bioPage.parents().not('body').addClass('overflow-visible no-transform');
	} else {
		This.bioPage.parents().not('body').removeClass('overflow-visible no-transform');
	}
}

function scrollSpy(This) {
	let profileImage = This.bioPage.find(BIOPAGECLS + 'profileImage');
	let offsetTop = (profileImage.offset().top - $(window).scrollTop()) || 120;

	$(window).resize(() => {
		affixImg(This, profileImage, offsetTop);
	});

	if (!utils.isSmallerThanTablet()) {
		This.bioPage.on('scroll', function() {
			profileImage.trigger('sticky_kit:recalc');
		});
	}

	affixImg(This, profileImage, offsetTop);
}

function affixImg(This, profileImage, offsetTop) {
	if (!utils.isSmallerThanTablet()) {
		profileImage.stick_in_parent({
			offset_top: offsetTop,
		});

		This.bioPage.trigger('scroll');
	}
}
